"use strict";

var _regeneratorRuntime = require("/Users/nightmail/Documents/SourceCode/codb.io/web/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/nightmail/Documents/SourceCode/codb.io/web/node_modules/@babel/runtime/helpers/asyncToGenerator");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lodash_1 = __importDefault(require("lodash"));

var remote_items_1 = __importDefault(require("../constants/actions/remote-items"));

var api_1 = __importDefault(require("../api"));

var RemoteGroupsCache = __importStar(require("../utils/cache/remote-groups"));

var followed_status_1 = __importDefault(require("../constants/followed-status"));

var my_error_1 = __importDefault(require("../models/my-error"));

var remote_item_approve_state_1 = __importDefault(require("../constants/remote-item-approve-state"));

var row_view_type_1 = __importDefault(require("../constants/row-view-type"));

var UtilsRemoteItem = __importStar(require("../utils/remote-item"));

var UtilsRemoteGroup = __importStar(require("../utils/remote-group"));

function _getFollowedStatus(_x) {
  return _getFollowedStatus2.apply(this, arguments);
}

function _getFollowedStatus2() {
  _getFollowedStatus2 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee7(groupId) {
    var is_followed;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return api_1.default.FollowedGroups.checkIfFollowed(groupId);

          case 2:
            is_followed = _context7.sent;
            return _context7.abrupt("return", is_followed ? followed_status_1.default.FOLLOWED : followed_status_1.default.NOT_FOLLOWED);

          case 4:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _getFollowedStatus2.apply(this, arguments);
}

function _getList(_x2, _x3, _x4) {
  return _getList2.apply(this, arguments);
}

function _getList2() {
  _getList2 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee8(group, userId, isReload) {
    var groupId, owner_id, list, myPendingList, myRejectedList;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            groupId = group.id, owner_id = group.owner_id;
            _context8.next = 3;
            return UtilsRemoteItem.getItemsByGroupId({
              groupId: groupId,
              isOnlyMine: false,
              isReload: isReload
            });

          case 3:
            list = _context8.sent;

            if (!(userId !== null && userId !== owner_id)) {
              _context8.next = 12;
              break;
            }

            _context8.next = 7;
            return api_1.default.Items.loadPending(groupId, [], [], userId);

          case 7:
            myPendingList = _context8.sent;
            _context8.next = 10;
            return api_1.default.Items.loadRejected(groupId, [], [], userId);

          case 10:
            myRejectedList = _context8.sent;
            list = lodash_1.default.unionBy(lodash_1.default.concat(list, myPendingList, myRejectedList), 'id');

          case 12:
            return _context8.abrupt("return", list);

          case 13:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _getList2.apply(this, arguments);
}

function _isListHasAtLeastOneWithIcon(list) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = list[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var item = _step.value;

      if (item.icon) {
        return true;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return false;
}

function _getListViewType(list) {
  if (list.length > 1000) {
    return row_view_type_1.default.ONLY_TITLE;
  } else {
    var hasAtLeastOneIcon = _isListHasAtLeastOneWithIcon(list);

    if (!hasAtLeastOneIcon) {
      return row_view_type_1.default.ONLY_TITLE;
    }

    var length = list.length;

    if (length >= 5) {
      return row_view_type_1.default.SIMPLE;
    } else {
      return row_view_type_1.default.REGULAR;
    }
  }
}

function updateOwnerMenuIndex(index) {
  return function (dispatch, getState) {
    dispatch({
      type: remote_items_1.default.UPDATE_OWNER_MENU_INDEX,
      index: index
    });
  };
}

exports.updateOwnerMenuIndex = updateOwnerMenuIndex;

function updateQuickFilterOptions(options) {
  return function (dispatch) {
    dispatch({
      type: remote_items_1.default.UPDATE_USERS_QUICK_FILTER_OPTIONS,
      options: options
    });
  };
}

exports.updateQuickFilterOptions = updateQuickFilterOptions;

function selectViewType(type) {
  return function (dispatch, getState) {
    dispatch({
      type: remote_items_1.default.SELECT_VIEW_TYPE,
      view_type: type
    });
  };
}

exports.selectViewType = selectViewType;

function selectSort(sortId) {
  return function (dispatch, getState) {
    dispatch({
      type: remote_items_1.default.SELECT_SORT,
      sort: sortId
    });
  };
}

exports.selectSort = selectSort;

function getFollowedStatus(opts) {
  return (
    /*#__PURE__*/
    function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(dispatch, getState) {
        var curStatus, groupId;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                curStatus = getState().remoteItems.user_follow_status;

                if (!(curStatus !== followed_status_1.default.IDEL)) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return");

              case 3:
                dispatch({
                  type: remote_items_1.default.GET_FOLLOWED_STATUS_INIT
                });
                _context.prev = 4;
                groupId = opts.group_id;
                _context.t0 = dispatch;
                _context.t1 = remote_items_1.default.GET_FOLLOWED_STATUS_SUCCESS;
                _context.next = 10;
                return _getFollowedStatus(groupId);

              case 10:
                _context.t2 = _context.sent;
                _context.t3 = {
                  type: _context.t1,
                  status: _context.t2
                };
                (0, _context.t0)(_context.t3);
                _context.next = 18;
                break;

              case 15:
                _context.prev = 15;
                _context.t4 = _context["catch"](4);
                dispatch({
                  type: remote_items_1.default.GET_FOLLOWED_STATUS_FAILURE
                });

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[4, 15]]);
      }));

      return function (_x5, _x6) {
        return _ref.apply(this, arguments);
      };
    }()
  );
}

exports.getFollowedStatus = getFollowedStatus;

function search(searchText) {
  return function (dispatch, getState) {
    dispatch({
      type: remote_items_1.default.SEARCH,
      query: searchText
    });
  };
}

exports.search = search;

function init(opts) {
  return (
    /*#__PURE__*/
    function () {
      var _ref2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(dispatch, getState) {
        var _getState, remoteItems, groupId, group, _group, groupOwnerId, count_new_pending_items, userId, isGroupOwner, list, ownerPendingList;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                dispatch({
                  type: remote_items_1.default.GET_LIST_INIT
                });
                _context2.prev = 1;
                _getState = getState(), remoteItems = _getState.remoteItems;
                groupId = opts.group_id;
                group = RemoteGroupsCache.getById(groupId);

                if (group) {
                  _context2.next = 14;
                  break;
                }

                _context2.next = 8;
                return api_1.default.Groups.getById(groupId);

              case 8:
                group = _context2.sent;

                if (group) {
                  _context2.next = 13;
                  break;
                }

                throw new my_error_1.default("Database not found");

              case 13:
                RemoteGroupsCache.updateOne(group);

              case 14:
                _group = group, groupOwnerId = _group.owner_id, count_new_pending_items = _group.count_new_pending_items;
                userId = api_1.default.Auth.getUserIdSync();
                isGroupOwner = groupOwnerId === userId;
                _context2.next = 19;
                return _getList(group, userId, false);

              case 19:
                list = _context2.sent;
                ownerPendingList = remoteItems.owner_pending_list;

                if (!isGroupOwner) {
                  _context2.next = 29;
                  break;
                }

                if (!(count_new_pending_items !== 0)) {
                  _context2.next = 25;
                  break;
                }

                _context2.next = 25;
                return api_1.default.Groups.resetNewPendingItemsCounter(groupId);

              case 25:
                if (!(ownerPendingList.length === 0)) {
                  _context2.next = 29;
                  break;
                }

                _context2.next = 28;
                return api_1.default.Items.loadPending(groupId, [], [], null);

              case 28:
                ownerPendingList = _context2.sent;

              case 29:
                _context2.t0 = dispatch;
                _context2.t1 = remote_items_1.default.GET_LIST_SUCCESS;
                _context2.t2 = group;
                _context2.t3 = list;
                _context2.t4 = _getListViewType(list);
                _context2.t5 = ownerPendingList;
                _context2.next = 37;
                return UtilsRemoteGroup.getPredefinedQuickFilterOptions(group);

              case 37:
                _context2.t6 = _context2.sent;
                _context2.t7 = {
                  type: _context2.t1,
                  group: _context2.t2,
                  list: _context2.t3,
                  view: _context2.t4,
                  owner_pending_list: _context2.t5,
                  quick_filter_options: _context2.t6
                };
                (0, _context2.t0)(_context2.t7);
                _context2.next = 45;
                break;

              case 42:
                _context2.prev = 42;
                _context2.t8 = _context2["catch"](1);
                dispatch({
                  type: remote_items_1.default.GET_LIST_FAILURE,
                  error: _context2.t8
                });

              case 45:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[1, 42]]);
      }));

      return function (_x7, _x8) {
        return _ref2.apply(this, arguments);
      };
    }()
  );
}

exports.init = init;

function reload() {
  return (
    /*#__PURE__*/
    function () {
      var _ref3 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(dispatch, getState) {
        var state, remoteItems, group, owner_menu_index, groupId, groupOwnerId, userId, isGroupOwner, list, owner_pending_list;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                dispatch({
                  type: remote_items_1.default.RELOAD_INIT
                });
                _context3.prev = 1;
                state = getState();
                remoteItems = state.remoteItems;
                group = remoteItems.group, owner_menu_index = remoteItems.owner_menu_index;
                groupId = group.id, groupOwnerId = group.owner_id;
                userId = api_1.default.Auth.getUserIdSync();
                isGroupOwner = groupOwnerId === userId;
                _context3.next = 10;
                return _getList(group, userId, true);

              case 10:
                list = _context3.sent;

                if (!isGroupOwner) {
                  _context3.next = 17;
                  break;
                }

                _context3.next = 14;
                return api_1.default.Items.loadPending(groupId, [], [], null);

              case 14:
                _context3.t0 = _context3.sent;
                _context3.next = 18;
                break;

              case 17:
                _context3.t0 = [];

              case 18:
                owner_pending_list = _context3.t0;

                if (owner_pending_list.length === 0) {
                  owner_menu_index = 0;
                }

                _context3.t1 = dispatch;
                _context3.t2 = remote_items_1.default.RELOAD_SUCCESS;
                _context3.t3 = list;
                _context3.next = 25;
                return _getFollowedStatus(groupId);

              case 25:
                _context3.t4 = _context3.sent;
                _context3.t5 = owner_pending_list;
                _context3.t6 = _getListViewType(list);
                _context3.t7 = owner_menu_index;
                _context3.next = 31;
                return UtilsRemoteGroup.getPredefinedQuickFilterOptions(group);

              case 31:
                _context3.t8 = _context3.sent;
                _context3.t9 = {
                  type: _context3.t2,
                  list: _context3.t3,
                  followed_status: _context3.t4,
                  owner_pending_list: _context3.t5,
                  view: _context3.t6,
                  owner_menu_index: _context3.t7,
                  quick_filter_options: _context3.t8
                };
                (0, _context3.t1)(_context3.t9);
                _context3.next = 39;
                break;

              case 36:
                _context3.prev = 36;
                _context3.t10 = _context3["catch"](1);
                dispatch({
                  type: remote_items_1.default.RELOAD_FAILURE,
                  error: _context3.t10
                });

              case 39:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[1, 36]]);
      }));

      return function (_x9, _x10) {
        return _ref3.apply(this, arguments);
      };
    }()
  );
}

exports.reload = reload;

function clear() {
  return function (dispatch, getState) {
    dispatch({
      type: remote_items_1.default.CLEAR
    });
  };
}

exports.clear = clear;

function resubmit(itemId, groupData) {
  return (
    /*#__PURE__*/
    function () {
      var _ref4 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(dispatch, getState) {
        var is_auto_approve, groupId, item;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                dispatch({
                  type: remote_items_1.default.RESUBMIT_INIT,
                  group_data: groupData,
                  item_id: itemId
                });
                _context4.prev = 1;

                if (groupData) {
                  _context4.next = 4;
                  break;
                }

                throw new my_error_1.default("Database not found");

              case 4:
                is_auto_approve = groupData.is_auto_approve, groupId = groupData.id;
                _context4.next = 7;
                return api_1.default.Items.resubmit(itemId, is_auto_approve ? remote_item_approve_state_1.default.APPROVED : remote_item_approve_state_1.default.PENDING);

              case 7:
                _context4.next = 9;
                return api_1.default.Items.getById(itemId);

              case 9:
                item = _context4.sent;

                if (item) {}

                dispatch({
                  type: remote_items_1.default.RESUBMIT_SUCCESS,
                  group_data: groupData,
                  item_id: itemId,
                  item_data: item
                });
                _context4.next = 17;
                break;

              case 14:
                _context4.prev = 14;
                _context4.t0 = _context4["catch"](1);
                dispatch({
                  type: remote_items_1.default.RESUBMIT_FAILURE,
                  error: _context4.t0,
                  group_data: groupData,
                  item_id: itemId
                });

              case 17:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[1, 14]]);
      }));

      return function (_x11, _x12) {
        return _ref4.apply(this, arguments);
      };
    }()
  );
}

exports.resubmit = resubmit;

function remove(itemId) {
  return (
    /*#__PURE__*/
    function () {
      var _ref5 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(dispatch, getState) {
        var groupId;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                dispatch({
                  type: remote_items_1.default.REMOVE_INIT
                });
                _context5.prev = 1;
                groupId = getState().remoteItems.group.id;
                _context5.next = 5;
                return api_1.default.Items.remove(itemId);

              case 5:
                dispatch({
                  type: remote_items_1.default.REMOVE_SUCCESS,
                  item_id: itemId
                });
                _context5.next = 11;
                break;

              case 8:
                _context5.prev = 8;
                _context5.t0 = _context5["catch"](1);
                dispatch({
                  type: remote_items_1.default.REMOVE_FAILURE,
                  error: _context5.t0
                });

              case 11:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[1, 8]]);
      }));

      return function (_x13, _x14) {
        return _ref5.apply(this, arguments);
      };
    }()
  );
}

exports.remove = remove;

function detach(itemId) {
  return (
    /*#__PURE__*/
    function () {
      var _ref6 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6(dispatch, getState) {
        var groupId;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                dispatch({
                  type: remote_items_1.default.DETACH_INIT
                });
                _context6.prev = 1;
                groupId = getState().remoteItems.group.id;
                _context6.next = 5;
                return api_1.default.Items.detach(itemId);

              case 5:
                dispatch({
                  type: remote_items_1.default.DETACH_SUCCESS,
                  item_id: itemId
                });
                _context6.next = 11;
                break;

              case 8:
                _context6.prev = 8;
                _context6.t0 = _context6["catch"](1);
                dispatch({
                  type: remote_items_1.default.DETACH_FAILURE,
                  error: _context6.t0
                });

              case 11:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[1, 8]]);
      }));

      return function (_x15, _x16) {
        return _ref6.apply(this, arguments);
      };
    }()
  );
}

exports.detach = detach;